<div class="home-stats">
  <div class="home-stats-panel">
    @for (stat of stats; track stat.labelKey) {
      <div class="home-stats-item">
        <div class="home-stats-value">{{ stat.valueKey | translate }}</div>
        <div class="home-stats-label">{{ stat.labelKey | translate }}</div>
      </div>
    }
  </div>
</div>
